import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducers from './frontend/redux/reducers/index-reduces';
import initialState from './frontend/redux/reducers/initial-state';
import { isClient, isServer, getWindow, safeSessionStorage, safeStringify } from 'frontend/helpers/ssr-helper';

const win = getWindow();
const preloadedState = isServer ? initialState : win?.__PRELOADED_STATE__;
const composeEnhancers = isServer ? compose() : (win?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose());

const store = createStore(reducers, preloadedState, composeEnhancers(applyMiddleware(thunkMiddleware)));

if (isClient) {
  setTimeout(() => {
    const state = store.getState();
    const templateData = state?.applicationState?.templateData;
    const applicationId = state?.applicationState?.applicationId;

    if (templateData && applicationId) {
      try {
        const dataToSave = {
          ...templateData,
          timestamp: Date.now(),
          applicationId: applicationId
        };

        const safeJsonString = safeStringify(dataToSave);
        safeSessionStorage.setItem('templateData', safeJsonString);
      } catch (error) {
        console.warn('Error saving template data to sessionStorage:', error);
      }
    }
  }, 100);
}

export default store;
